export const AppColors = {
  appbackgroundColor: "#282c34",
};


export function openURL(url) {
  window.open(url, "_blank");
}